/**
 * The mock backend's demo organisations. Northlight Studio holds the sample portfolio; Laterite Collective is a
 * second organisation so the switcher has somewhere to go (FR-PROJ-091). Organisations that staff create from the
 * console start empty. Identity and projects mocks both key their data by these ids.
 */
export const DEMO_ORGS = {
  northlight: "org-northlight",
  laterite: "org-laterite",
} as const;

/** Projects visible only to their team, Owners, Admins and people granted access (FR-ADMIN-013, 028). */
export const CONFIDENTIAL_PROJECTS: ReadonlySet<string> = new Set(["gachibowli-tower"]);
